<div class="media profile-media custom-profile">

    <img class="b-r-10 custom-image" src="{{userDetails.dp_url}}"
        (error)="userDetails.dp_url = 'assets/images/dashboard/profile.jpg';" alt="">
    <div class="media-body">
        <!-- <span>{{userDetails.name}} <i class="middle fa fa-angle-down"></i></span>
        <p class="mb-0 font-roboto"
            *ngIf="commonLogics.roleCtrl([constant.RoleId.superAdmin, constant.RoleId.admin], 'checkRoleIsEqual')">
            {{userDetails.role_name}}</p> -->
    </div>
</div>
<ul class="profile-dropdown onhover-show-div">
    <!-- <li (click)="openAccount(content);">
        <a>
            <app-feather-icons [icon]="'user'"></app-feather-icons><span>Account </span>
        </a>
    </li> -->
    <!-- <li><a href="#">
      <app-feather-icons [icon]="'mail'"></app-feather-icons><span>Inbox</span>
    </a></li>
  <li><a href="#">
      <app-feather-icons [icon]="'file-text'"></app-feather-icons><span>Taskboard</span>
    </a></li>
  <li><a href="#">
      <app-feather-icons [icon]="'settings'"></app-feather-icons><span>Settings</span>
    </a></li> -->

    <li (click)="authService.logout()">
        <a>
            <app-feather-icons [icon]="'log-in'"></app-feather-icons><span>Log out</span>
        </a>
    </li>

</ul>

<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Settings</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="firstFormGroup" class="account-setting-form" autocomplete="off"
        (ngSubmit)="userUpdate(firstFormGroup.value)">
        <div class="modal-body">
            <div class="row row--gutter">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                        <label for="exampleInputPassword1">First name<span class="required">*</span></label>
                        <input class="form-control" id="exampleInputPassword1" type="first_name" autocomplete="off"
                            onlyAlphabets
                            [class.is-valid]="firstFormGroup.get('first_name').dirty && firstFormGroup.get('first_name').valid"
                            [class.is-invalid]="(firstFormGroup.get('first_name').dirty && !firstFormGroup.get('first_name').valid)"
                            placeholder="Enter first name" formControlName="first_name">
                        <div *ngIf="firstFormGroup.get('first_name').errors?.required && submitted" class="errors">
                            First Name is required
                        </div>
                    </div>
                </div>

                <!-- <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                        <label for="exampleInputPassword1">Last name</label>
                        <input class="form-control" id="exampleInputcPassword1" type="last_name" autocomplete="off" onlyAlphabets
                            [class.is-valid]="firstFormGroup.get('last_name').dirty && firstFormGroup.get('last_name').valid"
                            [class.is-invalid]="(firstFormGroup.get('last_name').dirty && !firstFormGroup.get('last_name').valid)"
                            placeholder="Enter last name" formControlName="last_name">
                            </div>
                </div> -->

                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                        <label for="exampleInputPassword1">Email</label>
                        <input class="form-control" id="exampleInputcPassword1" type="text"
                            placeholder="Enter email address" formControlName="email" readonly>
                    </div>
                </div>

                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                        <label for="validationCustom01">Mobile<span class="required">*</span></label>
                        <input class="form-control" id="validationCustom01" type="number" formControlName="phone"
                            placeholder="Mobile number">
                        <div *ngIf="firstFormGroup.get('phone').errors?.required && submitted" class="errors">Mobile
                            Number is required</div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12" *ngIf="commonLogics.roleCtrl([4, 5, 10], 'checkRoleIsEqual');">
                    <div class="form-group">
                        <label class="control-label">Minimum Km<span class="required">*</span></label>
                        <input class="form-control" placeholder="Minimum km" onlyNumbers
                            [class.is-valid]="firstFormGroup.get('min_km').dirty && firstFormGroup.get('min_km').valid"
                            [class.is-invalid]="firstFormGroup.get('min_km').dirty && !firstFormGroup.get('min_km').valid"
                            formControlName="min_km" [readonly]="readonlyField">
                        <div *ngIf="firstFormGroup.get('min_km').errors?.required && submitted" class="errors">Min km is
                            required</div>

                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12" *ngIf="commonLogics.roleCtrl([4, 5, 10], 'checkRoleIsEqual');">
                    <div class="form-group">
                        <label class="control-label">Minimum Km price<span class="required">*</span></label>
                        <input class="form-control" placeholder="Minimum km price" onlyNumbers
                            [class.is-valid]="firstFormGroup.get('min_km_price').dirty && firstFormGroup.get('min_km_price').valid"
                            [class.is-invalid]="firstFormGroup.get('min_km_price').dirty && !firstFormGroup.get('min_km_price').valid"
                            formControlName="min_km_price" [readonly]="readonlyField">
                        <div *ngIf="firstFormGroup.get('min_km_price').errors?.required && submitted" class="errors">Min
                            km price is required</div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12" *ngIf="commonLogics.roleCtrl([4, 5, 10], 'checkRoleIsEqual');">
                    <div class="form-group">
                        <label class="control-label">Price per Km<span class="required">*</span></label>
                        <input class="form-control" placeholder="price per km" onlyNumbers
                            [class.is-valid]="firstFormGroup.get('price_per_km').dirty && firstFormGroup.get('price_per_km').valid"
                            [class.is-invalid]="firstFormGroup.get('price_per_km').dirty && !firstFormGroup.get('price_per_km').valid"
                            formControlName="price_per_km" [readonly]="readonlyField">
                        <div *ngIf="firstFormGroup.get('price_per_km').errors?.required && submitted" class="errors">
                            Price per km is required</div>

                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12"
                    *ngIf="commonLogics.roleCtrl([1, 2, 4, 5, 6, 10], 'checkRoleIsEqual');">
                    <div class="form-group">
                        <label>Date format</label>
                        <ng-select class="custom-select" bindLabel="date" bindValue="date" placeholder="Select"
                            formControlName="date_time_format" [searchable]="true" [items]="constant.dateFormatList">
                        </ng-select>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 mb-3" *ngIf="commonLogics.roleCtrl([6], 'checkRoleIsEqual');"
                    (click)="geocodeGoogleAutoCompleteModel()">
                    <div class="form-group">
                        <label class="control-label">Address</label>
                        <textarea class="form-control" placeholder="address" formControlName="address"
                            [readonly]="true"></textarea>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 mb-3 d-flex justify-content-start align-items-center"
                    *ngIf="commonLogics.roleCtrl([4, 5, 10], 'checkRoleIsEqual');">
                    <p class="mb-0 mr-2">Disable rider price in app</p>
                    <div class="media custom--switch d-inline mb-0">
                        <div class="media-body icon-state">
                            <label class="switch">
                                <input type="checkbox" formControlName="disable_rider_price_in_app"><span
                                    class="switch-state"></span>
                            </label>
                        </div>
                        <!-- <label class="col-form-label m-l-10">Per order</label> -->
                    </div>
                </div>

                <!-- <div class="col-lg-6 col-md-6 col-sm-12" *ngIf="commonLogics.roleCtrl([1, 2, 4, 5, 6, 10], 'checkRoleIsEqual');">
                    <div class="form-group">
                        <label>Currency format</label>
                        <ng-select class="custom-select" bindLabel="countryCode" bindValue="symbol" placeholder="Select" formControlName="currency_symbol" [searchable]="true" [items]="constant.currencyList"></ng-select>
                    </div>
                </div> -->

            </div>

            <div class="row row--gutter">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="user-image upload-img-wrapper">
                        <div class="form-group">
                            <!-- <label for="image" *ngIf="commonLogics.roleCtrl([4, 5, 6, 10], 'checkRoleIsEqual');">Logo image</label> -->
                            <!-- <label for="image">Profile
                image</label> -->
                            <div class="avatar hei-wid-auto"><img alt="" src="{{dp_url}}"
                                    (error)="dp_url = 'assets/images/user/user.png';">
                                <div class="icon-wrapper"><i class="icofont icofont-pencil-alt-5"><input class="upload"
                                            #myInput type="file" (change)="uploadProfileImage($event)" /></i>
                                </div>
                            </div>
                            <h6>Profile Image</h6>
                        </div>
                    </div>
                    <p class="indicator-message">
                        <small>Profile image:<br> 200 x 200 pixels</small>
                    </p>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12" *ngIf="whiteLabel">
                    <div class="user-image upload-img-wrapper">
                        <div class="form-group">
                            <!-- <label for="image">Logo image</label> -->
                            <div class="avatar hei-wid-auto"><img alt="" src="{{logo_url}}"
                                    (error)="logo_url = 'assets/images/logo/logo.png';">
                                <div class="icon-wrapper"><i class="icofont icofont-pencil-alt-5"><input class="upload"
                                            #mylogo type="file" (change)="uploadLogoImage($event)" /></i>
                                </div>
                            </div>
                            <h6>Logo Image</h6>
                        </div>
                    </div>
                    <p class="indicator-message">
                        <small>Main logo:<br> 150 x 50 pixels</small>
                    </p>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12" *ngIf="whiteLabel">
                    <div class="user-image upload-img-wrapper">
                        <div class="form-group">
                            <!-- <label for="image">Logo icon</label> -->
                            <div class="avatar hei-wid-auto"><img alt="" src="{{icon_url}}"
                                    (error)="icon_url = 'assets/images/logo/ad-logo.svg';">
                                <div class="icon-wrapper"><i class="icofont icofont-pencil-alt-5"><input class="upload"
                                            #mylogoIcon type="file" (change)="uploadIconImage($event)" /></i>
                                </div>
                            </div>
                            <h6>Logo Icon</h6>
                        </div>
                    </div>
                    <p class="indicator-message">
                        <small>Logo icon:<br> 200 x 200 pixels</small>
                    </p>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Close</button>
                <button class="btn btn-primary pull-right" type="submit">Update</button>
            </div>
        </div>
    </form>
</ng-template>